import React, { useMemo, useState } from 'react'

import { Button, Checkbox, Icon, Modal, Popconfirm, Row, Select, Table } from 'antd'

import { getMessage } from '../../../util/IntlMessages'
import InlineInput from './InlineInput'

import './Cultivars.css'

const { confirm } = Modal

const ListCultivars = ({
  onRemoveCultivarItems,
  onUpdateCultivarsItem,
  formattedDemandTypes = [],
  formattedCultivarsTypes = [],
  cultivarsItems = [],
  formattedMaterials = []
}) => {
  const [selectedCultivars, setSelectedCultivars] = useState([])
  const [editingItem, setEditingItem] = useState({})

  function handleCheckAll() {
    const selected = selectedCultivars.length ? [] : cultivarsItems.map(({ id }) => id)
    setSelectedCultivars(selected)
  }

  function handleCheckSingle(id) {
    if (selectedCultivars.includes(id)) {
      return setSelectedCultivars(selectedCultivars.filter((key) => key !== id))
    }
    setSelectedCultivars([...selectedCultivars, id])
  }

  const renderTitleCheckbox = () => (
    <Checkbox
      indeterminate={selectedCultivars.length !== cultivarsItems.length && selectedCultivars.length}
      onClick={handleCheckAll}
      checked={selectedCultivars.length && selectedCultivars.length === cultivarsItems.length}
    />
  )

  const renderItemCheckbox = ({ id }) => (
    <Checkbox onClick={() => handleCheckSingle(id)} checked={selectedCultivars.includes(id)} />
  )

  const renderSelectWithCultivarId = (field, cultivarId, values, options = []) => {
    return (
      <Select className="inline-select" value={values}>
        {options.map((item) => (
          <Select.Option
            key={item.value}
            value={item.value}
            onClick={() => onUpdateCultivarsItem(field, cultivarId, item.value)}
          >
            {item.description}
          </Select.Option>
        ))}
      </Select>
    )
  }

  function renderInlineInput(item) {
    return (
      <InlineInput
        item={item}
        field="area"
        currentItem={editingItem}
        setEditingItem={setEditingItem}
        parseFunction={Number}
        onSubmit={onUpdateCultivarsItem}
      />
    )
  }

  const renderPopConfirm = (ids) => (
    <Popconfirm title={getMessage('SureToDelete?')} onConfirm={() => onRemoveCultivarItems(ids)}>
      <Icon type="delete" theme="outlined" className="trash-icon" />
    </Popconfirm>
  )

  const columns = [
    {
      title: renderTitleCheckbox(),
      dataIndex: 'checkbox',
      key: 'checkbox',
      width: '2%',
      align: 'center',
      render: (text, record) => renderItemCheckbox(record)
    },
    {
      title: getMessage('material'),
      dataIndex: 'materialsId',
      key: 'materialsId',
      width: '15%',
      align: 'center',
      render: (text, record) =>
        renderSelectWithCultivarId('materialsId', record.id, record.materialsId, formattedMaterials)
    },
    {
      title: getMessage('brand'),
      dataIndex: 'materials.brand.name',
      key: 'materials.brand.name',
      width: '15%',
      align: 'center'
    },
    {
      title: getMessage('technology'),
      dataIndex: 'materials.tecnologia.name',
      key: 'materials.tecnologia.name',
      width: '15%',
      align: 'center'
    },
    {
      title: getMessage('demand'),
      dataIndex: 'cultivarsDemandTypeId',
      key: 'cultivarsDemandTypeId',
      width: '15%',
      align: 'center',
      render: (text, record) =>
        renderSelectWithCultivarId(
          'cultivarsDemandTypeId',
          record.id,
          record.cultivarsDemandTypeId,
          formattedDemandTypes
        )
    },
    {
      title: getMessage('area'),
      dataIndex: 'area',
      key: 'area',
      width: '15%',
      align: 'center',
      render: (text, record) => renderInlineInput(record)
    },
    {
      title: getMessage('cultivarsTypeId'),
      dataIndex: 'cultivarsTypeId',
      key: 'cultivarsTypeId',
      width: '15%',
      align: 'center',
      render: (text, record) =>
        renderSelectWithCultivarId('cultivarsTypeId', record.id, record.cultivarsTypeId, formattedCultivarsTypes)
    },
    {
      title: getMessage('actions.table.field.actions'),
      dataIndex: 'actions',
      key: 'actions',
      width: '5%',
      align: 'center',
      render: (text, record) => renderPopConfirm([record.id])
    }
  ]

  const showDeleteConfirmationDialog = (callback = () => ({})) =>
    confirm({
      title: getMessage('SureToDelete?'),
      okText: 'Confirmar',
      cancelText: 'Cancelar',
      icon: null,
      content: '',
      onOk() {
        callback()
      }
    })

  const renderTable = useMemo(
    () => <Table rowKey="id" bordered className="cultivars-table" columns={columns} dataSource={cultivarsItems} />,
    [cultivarsItems, formattedMaterials, selectedCultivars, editingItem]
  )

  return (
    <>
      <Row type="flex" justify="end">
        <Button
          className="del-all-btn"
          icon="delete"
          type="ghost"
          onClick={() => showDeleteConfirmationDialog(() => onRemoveCultivarItems(selectedCultivars))}
        >
          {getMessage('deleteSelected')}
        </Button>
      </Row>

      {renderTable}
    </>
  )
}

export default ListCultivars
